import axios from 'axios'


/**
 *
 * @status no delete
 * @class ClientService
 */
class ClientService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Lucia Alvarado
  * @description Handle event to create a new client in A3Cloud
  * @date 20-07-2020
  * @param {String} token
  * @param {Object} client
  * @returns {Object}
  * @memberof ClientService
  */
  async createClient(token, client) {
    let { personTypeId, organization } = client
    let response = await axios.post(`${this.apiUrl}/client`, {
      personTypeId,
      organization
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }



  /**
  * @author Gustavo Pacheco
  * @description enviar imagen del cliente al back-end
  * @date 02-06-2021
  * @status no delete
  * @param {String} token
  * @param {Object} img
  * @returns {Object}
  * @memberof ClientService
  */
  async sendClientImage(token, data) {
    let response = await axios.put(`${this.apiUrl}/client-image-passthrough`, data, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
    // return { data: { image: 'https://www.tailorbrands.com/wp-content/uploads/2020/07/twitter-logo.jpg' } }
  }


  /**
  * @author Gustavo Pacheco
  * @description traer imagen del cliente al back-end
  * @date 02-06-2021
  * @status no delete
  * @param {String} token
  * @param {Object} img
  * @returns {Object}
  * @memberof ClientService
  */
  async getClientImage(token) {
    let response = await axios.get(`${this.apiUrl}/client-image-passthrough`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
  * @author Adriana Fernandez
  * @description traer las preferencias del usuario
  * @date 25-05-2023
  * @status no delete
  * @param {String} token
  * @param {String} timezone
  * @returns {Object}
  * @memberof ClientService
  */
  async getClientPreferences(token, timezone) {
    let response = await axios.get(`${this.apiUrl}/client-preference?timezone=${encodeURIComponent(timezone)}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
  * @author Adriana Fernandez
  * @description guardar las preferencias del usuario
  * @date 25-05-2023
  * @status no delete
  * @param {String} token
  * @param {Object} preferences
  * @returns {Object}
  * @memberof ClientService
  */
  async saveClientPreferences(token, preferences) {
    let response = await axios.post(`${this.apiUrl}/client-preference`,
      { config: preferences },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    return response.data
  }

  /**
  * @author Isaac Martinez
  * @description Update client profile information
  * @date 12-07-2024
  * @status no delete
  * @param {String} token
  * @param {Object} profileInformation
  * @returns {Object}
  * @memberof ClientService
  */
  async updateClientProfileInformation(token, profileInformation) {
    let response = await axios.put(`${this.apiUrl}/client-profile-information`, profileInformation,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        }
      })
    return response.data
  }
}

export { ClientService as default }
